// extracted by mini-css-extract-plugin
module.exports = {"label":"LocationDropdown-module__label___3se9g","counter":"LocationDropdown-module__counter___3hVvr","regionName":"LocationDropdown-module__regionName___2EWoz"};